import script from "./LiquorOrderingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LiquorOrderingForm.vue?vue&type=script&setup=true&lang=js"

import "./LiquorOrderingForm.vue?vue&type=style&index=0&id=55385c0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55385c0e"]])

export default __exports__